function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M36.985 0H7.963C7.155 0 6.5.655 6.5 1.926V55c0 .345.655 1 1.463 1h40.074c.808 0 1.463-.655 1.463-1V12.978c0-.696-.093-.92-.257-1.085L37.607.257A.884.884 0 0036.985 0z",
  fill: "#e9e9e0"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#d9d7ca",
  d: "M37.5.151V12h11.849z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M48.037 56H7.963A1.463 1.463 0 016.5 54.537V39h43v15.537c0 .808-.655 1.463-1.463 1.463z",
  fill: "#c8bdb8"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 18.5,
  cy: 47,
  r: 3,
  fill: "#fff"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 28.5,
  cy: 47,
  r: 3,
  fill: "#fff"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 38.5,
  cy: 47,
  r: 3,
  fill: "#fff"
});

var SvgFile = function SvgFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 56 56"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
};

export default SvgFile;